import { ToothDecayType } from '../../../../graphql/graphql';

// TODO: extend with other pathology terms, apply in buttons and later in history
export const PATHOLOGY_TRANSLATION_MAP = {
	[ToothDecayType.Primary]:
		'patientTreatment.meddiDENT.dentalCross.pathologyModal.decay.primary',
	[ToothDecayType.Secondary]:
		'patientTreatment.meddiDENT.dentalCross.pathologyModal.decay.secondary',
};
